var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMerchLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 39,
    viewBox: "0 0 37 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.21053 2.05263V16.4211L18.4737 11.2895L28.7368 16.4211V2.05263H34.8947C35.4391 2.05263 35.9612 2.26889 36.3462 2.65383C36.7311 3.03878 36.9474 3.56087 36.9474 4.10526V36.9474C36.9474 37.4918 36.7311 38.0139 36.3462 38.3988C35.9612 38.7837 35.4391 39 34.8947 39H2.05263C1.50824 39 0.986145 38.7837 0.601202 38.3988C0.216259 38.0139 0 37.4918 0 36.9474V4.10526C0 3.56087 0.216259 3.03878 0.601202 2.65383C0.986145 2.26889 1.50824 2.05263 2.05263 2.05263H8.21053ZM18.4737 10.2632L9.23684 0H27.7105L18.4737 10.2632ZM20.5263 16.9055L18.4737 15.8792L16.4211 16.9055V34.8947H20.5263V16.9055ZM24.6316 22.5789V26.6842H32.8421V22.5789H24.6316Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMerchLogo);
export default __webpack_public_path__ + "static/media/merch-logo.90cea7a0eb2bd44fb1088886caffaeb2.svg";
export { ForwardRef as ReactComponent };